import { render, staticRenderFns } from "./ChangePasswordCard.vue?vue&type=template&id=28e48949&scoped=true"
import script from "./ChangePasswordCard.ts?vue&type=script&lang=ts&external"
export * from "./ChangePasswordCard.ts?vue&type=script&lang=ts&external"
import style0 from "./ChangePasswordCard.vue?vue&type=style&index=0&id=28e48949&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e48949",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2316091614/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28e48949')) {
      api.createRecord('28e48949', component.options)
    } else {
      api.reload('28e48949', component.options)
    }
    module.hot.accept("./ChangePasswordCard.vue?vue&type=template&id=28e48949&scoped=true", function () {
      api.rerender('28e48949', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/User/components/ChangePasswordCard/ChangePasswordCard.vue"
export default component.exports